import { Button } from '@/components';
import { BUTTON_LABELS } from '@/constants';

/**
 * NextScorecardButton is a specialized button component used to navigate to the next scorecard.
 * It utilizes the Button component with specific props for styling and functionality.
 */
export const NextScorecardButton: React.FC<{ disabled?: boolean; onClick: () => void }> = ({
  disabled = false,
  onClick,
}) => {
  return (
    <Button
      disabled={disabled}
      iconRight="ArrowRight"
      label={BUTTON_LABELS.NEXT_SCORECARD}
      onClick={onClick}
      size="small"
      variant="tertiaryTwoTone"
    />
  );
};

NextScorecardButton.displayName = 'NextScorecardButton';

export default NextScorecardButton;
